import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import styles from "./index.module.scss";
import type { B2cProductPrice } from "@/generated/graphql/b2c";
import FixOptions from "@/elements-react/fix-options";

interface PricesSelectorProps {
  variations: B2cProductPrice[] | null;
  active?: string | null;
  onUpdatePrice?: (price: B2cProductPrice) => void;
}

const PricesSelector: React.FC<PricesSelectorProps> = ({
  variations,
  active: activeProp,
  onUpdatePrice,
}) => {
  const { t } = useTranslation();
  const [active, setActive] = useState<string | null>(activeProp ?? null);

  useEffect(() => {
    if (!active && variations && variations.length > 0) {
      setActive(variations[0].id);
      if (onUpdatePrice) onUpdatePrice(variations[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variations]);

  const handleUpdateActive = useCallback(
    (id: string) => {
      setActive(id);
      const price = variations?.find((item) => item.id === id);
      if (price && onUpdatePrice) onUpdatePrice(price);
    },
    [variations, onUpdatePrice]
  );

  if (!variations) return null;

  const renderOption = (item: B2cProductPrice) => (
    <div className={styles.option}>
      <div className={styles.dispatchTime}>
        {item.deliveryTermStandardMin} - {item.deliveryTermStandardMax}{" "}
        {t("zbn9rpiesbfiusbf.days", "days")}
      </div>
      <div className={styles.price}>{item.price.amount}</div>
    </div>
  );

  return (
    <div className={classNames(styles.root)}>
      <FixOptions
        options={variations}
        active={active}
        renderer={renderOption}
        direction="horizontal"
        onUpdateActive={handleUpdateActive}
      />
    </div>
  );
};

export default PricesSelector;

